import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, withLatestFrom } from 'rxjs/operators';

import * as PricingActions from './pricing.actions';
import { Store } from '@ngrx/store';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { PricingService } from '@boma/supplier-portal/shared/services';
import { fetch } from '@nx/angular';

@Injectable()
export class PricingEffects {
  loadPricings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PricingActions.loadPricings),
      withLatestFrom(this.store.select(getSelectedOrganizationInfo)),
      concatMap((action) => {
        const { payload } = action[0];
        const org = action[1];
        const { entityId, params } = payload;
        return this.pricingService.loadPricingGroups(entityId, params).pipe(
          map((data) =>
            PricingActions.loadPricingsSuccess({
              data,
            })
          )
        );
      })
    );
  });

  createPricingGroup$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PricingActions.createPricingGroup),

      fetch({
        run: (action, state: any) => {
          const payload = action.payload;
          const callback = action.onComplete;
          return this.pricingService.createPricingGroup(payload).pipe(
            map((pricingGroup) => {
              console.log('Pricing action create success', pricingGroup);
              if (callback) callback(pricingGroup);
              return PricingActions.createPricingGroupSuccess({
                payload: pricingGroup,
              });
            })
          );
        },

        onError: (action, error) => {
          console.error('Error', error);
          return PricingActions.createPricingGroupFailure({ error });
        },
      })
    );
  });

  updatePricingGroup$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PricingActions.updatePricingGroup),

      fetch({
        run: (action, state: any) => {
          const { id, payload } = action;
          console.log(payload);
          return this.pricingService.updatePricingGroup(id, payload).pipe(
            map((pricingGroup) => {
              console.log('Pricing action update success', pricingGroup);
              return PricingActions.updatePricingGroupSuccess({
                payload: pricingGroup,
              });
            })
          );
        },

        onError: (action, error) => {
          console.error('Error', error);
          return PricingActions.updatePricingGroupFailure({ error });
        },
      })
    );
  });

  deletePricingGroup$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PricingActions.deletePricingGroup),

      fetch({
        run: (action, state: any) => {
          const groupId = action.id;
          return this.pricingService
            .deletePricingGroup(action.entityId, action.id)
            .pipe(
              map((pricingGroup) => {
                return PricingActions.deletePricingGroupSuccess({ groupId });
              })
            );
        },

        onError: (action, error) => {
          console.error('Error', error);
          return PricingActions.deletePricingGroupFailure({ error });
        },
      })
    );
  });

  constructor(
    private actions$: Actions,
    private store: Store,
    private pricingService: PricingService
  ) {}
}
